import React, { useState } from 'react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'
import usersCollection from 'modules/core/store/collections/users'

import employeesCollection from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'

import FormSection from '../FormSection'
import BankSection from '../PayrollInformation/BankSection'

interface Props {
  employee: Employee
  canEdit: boolean
}

const BankInformation: React.FC<Props> = ({ employee, canEdit }) => {
  const { loading } = useAsyncData(
    () => Promise.all([usersCollection.fetch(), employeesCollection.fetch()]),
    []
  )

  const [bankShowSubmit, setBankShowSubmit] = useState(false)
  const [[submitBankEventHandler], setSubmitBankEventHandler] = useState<[() => void] | [null]>([
    null,
  ])

  const handleSubmit = () => {
    submitBankEventHandler?.()
  }

  return (
    <FormSection
      title={i18n.t('employee_form.payroll_section.bank_account')}
      description={i18n.t('employee_form.payroll_section.bank_description')}
      illustration="money"
      submitAction={() => handleSubmit()}
      disabled={!bankShowSubmit}
    >
      {loading && <Loading />}
      {!loading && (
        <BankSection
          employee={employee}
          readonly={!canEdit}
          setSubmitEventHandler={(onSubmit: (() => void) | null) =>
            setSubmitBankEventHandler([onSubmit])
          }
          setBankShowSubmit={setBankShowSubmit}
          showHeader={false}
        />
      )}
    </FormSection>
  )
}

export default BankInformation
